import { render, staticRenderFns } from "./GermanForm.vue?vue&type=template&id=fd6daecc&scoped=true&"
import script from "./GermanForm.vue?vue&type=script&lang=js&"
export * from "./GermanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6daecc",
  null
  
)

export default component.exports